import { Box } from "@mui/material";
import CustomButton from "../../../../UIElements/CustomButton";
import "../../../../components-styles.scss";
import "../../../profil-styles.scss";
import CancelModalButton from "../../../../UIElements/CustomModal/CancelModalButton";
import EstablishmentAdressFormWrapper from "../../../../Common/EstablishmentAdressFormWrapper";
import { postalAddress } from "../../../../../types";

type EditAdressFormProps = {
    onSubmit: (data: any) => void;
    defaultValue?: {
        contactAddress: postalAddress;
        billingAddress: postalAddress;
    };
};

export default function EditAdressForm({
    onSubmit,
    defaultValue,
}: EditAdressFormProps) {
    return (
        <Box className="profil-form-root">
            <EstablishmentAdressFormWrapper
                defaultValues={defaultValue}
                onSubmit={onSubmit}
                className="profil-form-container"
                formActionComponents={{
                    submit: (
                        <CustomButton
                            type="submit"
                            label="Enregister"
                            customsx={{
                                width: "100%",
                            }}
                        />
                    ),
                    cancel: (
                        <CancelModalButton
                            customsx={{
                                width: "100%",
                            }}
                        />
                    ),
                }}
                classes={{
                    adressFormElements: {
                        outlinedinputsx: {
                            border: "2px solid  #E3E6E8",
                        },
                    },
                }}
            />
        </Box>
    );
}
